import { useIsDesktop, useIsTablet } from "hooks/useDeviceType";
import { NavbarV2Desktop } from "./NavbarV2Desktop";
import { NavbarV2Tablet } from "./NavbarV2Tablet";

export const NavbarV2 = () => {
  const isDesktop = useIsDesktop();
  const isTablet = useIsTablet();

  if (isDesktop) {
    return <NavbarV2Desktop />;
  } else if (isTablet) {
    return <NavbarV2Tablet />;
  }
  return null;
};
